export const setTempreture = (temp) => ({
  type: 'SET_TEMPRETURE',
  payload: temp,
});

export const setLanguage = (lang) => ({
  type: 'SET_LANGUAGE',
  payload: lang,
});

export const setInputText = (value) => ({
  type: 'SET_INPUT_TEXT',
  payload: value,
});

export const setLoading = () => ({
  type: 'DATA_REQUESTED',
});

export const setLoaded = () => ({
  type: 'DATA_LOADED',
});

export const setError = (data) => ({
  type: 'DATA_ERROR',
  payload: data,
});

export const setVoice = (data) => ({
  type: 'SET_VOICE',
  payload: data,
});
